




































































import { Component, Prop, Vue } from 'vue-property-decorator';
import { BottomWrapper } from '../BottomWrapper.vue';
import { Bridge } from '@/common/bridge';
import { namespace } from 'vuex-class';
import { isEmailValid, isPhoneValid } from '@/common/utils';
import waiting from '@/components/loading/waiting';
import { LoginResult, PleasedUserInfo } from '@/common/types';

import * as rule from '@/common/lib/form-valid';

const userModule = namespace('user');

interface LoginForm {
  username: string;
  password: string;
}

@Component({
  components: {
    BottomWrapper,
  },
  directives: {
    waiting,
  },
})
export default class LoginGuest extends Vue {
  @userModule.State('country') country!: string;
  @userModule.Mutation('updateLoginStatus') updateLoginStatus!: Function;
  @userModule.Mutation('updatePleasedUser') updatePleasedUser!: (payload: PleasedUserInfo) => void;
  @userModule.Action('sportyLoginSuccess') sportyLoginSuccess!: (payload: LoginResult) => Promise<void>;

  @userModule.State('usernameFieldType') usernameFieldType!: 'phone' | 'email';

  @Prop({ default: false }) readonly isGuestAllowed!: boolean;

  loading = false;
  get buttons () {
    return [{
      name: this.t('page.login.button.login', 'Login'),
      id: '',
      isActive: true,
    }];
  };

  loginErrorFromApi = false;

  form = {
    username: '',
    password: '',
  };
  error = {
    username: '',
    password: '',
  };

  get userFieldType () {
    return this.usernameFieldType === 'email' ? {
      type: 'email',
      name: this.$t('global.email'),
      inputType: 'email',
    } : {
      type: 'phone',
      name: this.t('page.login.mobile.placeholder', 'Mobile no'),
      inputType: 'tel',
    };
  }

  get loginFormSuite (): rule.ValidationSuite<LoginForm> {
    return {
      username: [
        rule.c(rule.required, '{uFieldName} is required'),
        rule.c(
          (val: string, _: any, ctx: any) =>
            ctx.uFieldType === 'phone' ? isPhoneValid(val) : isEmailValid(val),
          'Please enter a valid {uFieldName}'
        ),
      ],
      password: [rule.c(rule.required, 'Password is required')],
    };
  };

  protected cleanPopListener: CallableFunction | null = null;

  created () {
    this.cleanPopListener = Bridge.onLoginFromPopup(async (data) => {
      this.loading = true;
      await this.onLoginSuccess(data);
    });
  }

  async submit () {
    this.loginErrorFromApi = false;
    this.loading = true;
    const { valid, errors } = await rule.validateForm(this.form, this.loginFormSuite, { uFieldType: this.userFieldType.type, uFieldName: this.userFieldType.name });
    this.error = Object.assign({}, this.error, errors);

    if (!valid) {
      this.loading = false;
      return;
    }
    const data = await Bridge.login({ username: this.form.username, password: this.form.password });
    await this.onLoginSuccess(data);
    this.loading = false;
  }

  destroyed () {
    this.cleanPopListener?.();
  }

  async onLoginSuccess (data: LoginResult) {
    if (data.bizCode === 10000) {
      await this.sportyLoginSuccess(data).catch(() => {});
      this.$emit('login');
    } else {
      this.loginErrorFromApi = true;
    }
  }
}
